import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FiTruck, FiArrowRightCircle } from 'react-icons/fi';
import Surface from '../ui/Surface';
import Button from '../ui/Button';
import { useQuotesBookings } from './QuotesBookingsContext';
import styles from './BookingFeed.module.css';

const BookingFeed = ({ bookings, className }) => {
  const { carriers } = useQuotesBookings();
  const carrierLookup = useMemo(() => Object.fromEntries(carriers.map((carrier) => [carrier.id, carrier])), [carriers]);

  return (
    <Surface padding="lg" className={[styles.feedSurface, className].filter(Boolean).join(' ')}>
      <div className={styles.header}>
        <div>
          <h3>Recent bookings</h3>
          <p>Confirmed tenders from the past seven days.</p>
        </div>
        <Button variant="ghost" size="sm">View all</Button>
      </div>
      <div className={styles.list}>
        {bookings.map((booking) => {
          const carrier = carrierLookup[booking.carrierId];
          return (
            <div key={booking.id} className={styles.item}>
              <div className={styles.marker}>
                <FiTruck />
              </div>
              <div className={styles.itemBody}>
                <div className={styles.itemHeader}>
                  <span className={styles.bookingId}>{booking.id}</span>
                  <span className={styles.bookingDate}>{booking.bookedOn}</span>
                </div>
                <div className={styles.lane}>{booking.origin} → {booking.destination}</div>
                <div className={styles.meta}>
                  <span>{booking.mode} · {booking.equipment}</span>
                  <span>{booking.value}</span>
                </div>
                {carrier && (
                  <div className={styles.carrier}>
                    <span>{carrier.name}</span>
                    <span className={styles.carrierMeta}>MC {carrier.mc} · DOT {carrier.dot}</span>
                  </div>
                )}
              </div>
              <Button variant="quiet" size="sm" className={styles.itemCta} trailingIcon={<FiArrowRightCircle />}>
                Manage
              </Button>
            </div>
          );
        })}
        {bookings.length === 0 && (
          <div className={styles.empty}>No bookings yet – convert a quote to see it appear here.</div>
        )}
      </div>
    </Surface>
  );
};

BookingFeed.propTypes = {
  bookings: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      bookedOn: PropTypes.string.isRequired,
      origin: PropTypes.string.isRequired,
      destination: PropTypes.string.isRequired,
      mode: PropTypes.string.isRequired,
      equipment: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      carrierId: PropTypes.string
    })
  ).isRequired,
  className: PropTypes.string
};

BookingFeed.defaultProps = {
  className: ''
};

export default BookingFeed;
